import { render, staticRenderFns } from "./InvoicePreview.vue?vue&type=template&id=da630baa&scoped=true&"
import script from "./InvoicePreview.vue?vue&type=script&lang=js&"
export * from "./InvoicePreview.vue?vue&type=script&lang=js&"
import style0 from "./InvoicePreview.vue?vue&type=style&index=0&id=da630baa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da630baa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VDialog})
